import { ThemesContainer as Themes } from './ThemesContainer'

// eslint-disable-next-line import/no-default-export
export default Themes
